import React, { useState, useEffect } from 'react'
import './home.css'
import { Unity, useUnityContext } from "react-unity-webgl"
import SideBar from '../../components/sidebar'
import PopUp from '../../components/popup'
import Search from '../../components/search'
import api from '../../services/api'

import LinksBox from '../../components/linksBox'

export default function Home() {
    const [pageId, setPageId] = useState(1)
    const [sidebarInfo, setSidebarInfo] = useState(null)
    const [pageInfo, setPageInfo] = useState(null)
    const [popUpInfo, setPopUpInfo] = useState({})
    const [popUpIsOpen, setPopUpIsOpen] = useState(false)
    const [linksBoxIsOpen, setLinksBoxIsOpen] = useState(false)
    const [links, setLinks] = useState({})
    const [searchIsOpen, setSearchIsOpen] = useState(false)

    const { unityProvider, loadingProgression, isLoaded, sendMessage, addEventListener, removeEventListener } =
    useUnityContext({
        loaderUrl: "buildUnity/WebGL.loader.js",
        dataUrl: "buildUnity/WebGL.data",
        frameworkUrl: "buildUnity/WebGL.framework.js",
        codeUrl: "buildUnity/WebGL.wasm",
    })

    const getSidebarContent = async () => {
        try{
            const response = await api.get(`/sidebars/${pageId}?populate=*`)

            if(response.data){
                setSidebarInfo(response.data.data.attributes)
                setPageInfo(response.data.data.attributes)
            }
        } catch(err) {
            console.log(err)
        }
    }

    const getNetworkContent = async (networkId) => {
        try{
            const qs = require('qs')
            const query = qs.stringify({
                populate: {
                    Assets: {
                        //populate: '*',
                        populate: [
                            "Image",
                            "Video",
                            "PDF",
                            "layer",
                            "solution",
                            "customer",
                            "Subtitles",
                            "Subtitles.VTT",
                        ],
                    },
                },
                }, {
                encodeValuesOnly: true,
            })

            const response = await api.get(`/networks/${networkId}?${query}`)
            if(response.data){
                setSidebarInfo(response.data.data.attributes)
                setLinks(response.data.data.attributes.Assets.data)
                setLinksBoxIsOpen(true)
            }
        } catch(err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getSidebarContent()
    }, [pageId])

    const handlePopUp = async (isOpen, contentId) => {
        if(!isOpen){
            sendMessage("ExternalInput", "ClosePoI")
            return setPopUpIsOpen(false)
        }
        
        try{
            const qs = require('qs')
            const query = qs.stringify({
            populate: {
                Assets: {
                    //populate: '*',
                    populate: [
                        "Image",
                        "Video",
                        "PDF",
                        "layer",
                        "solution",
                        "customer",
                        "Subtitles",
                        "Subtitles.VTT",
                    ],
                },
            },
            }, {
            encodeValuesOnly: true,
            })

            const response = await api.get(`/contents/${contentId}?${query}`)
            if(response.data){
                setPopUpInfo(response.data.data.attributes)
                setPopUpIsOpen(true)
            }
        } catch(err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getSidebarContent()
        addEventListener("changePage", (pageId) => {
            setPageId(pageId)
        })
        addEventListener("popup", (contentId) => {
            handlePopUp(true, contentId)
        })
        addEventListener("getNetworkContent", (networkId) => {
            getNetworkContent(networkId)
        })
        
    }, [])

    useEffect(() => {
        sendMessage("ContentService", "Initialize", process.env.REACT_APP_API_URL)
    }, [isLoaded])

    const handleLinksBox = (isOpenLinksBox, links) => {
        if(!isOpenLinksBox){
            setSidebarInfo(pageInfo)
            sendMessage("ExternalInput", "ClosePoI")
            return setLinksBoxIsOpen(false)
        }

        setLinksBoxIsOpen(true)
        setLinks(links)
    }

    const handleSearch = (isSearchOpen) => {
        if(!isSearchOpen){
            sendMessage("ExternalInput", "ClosePoI")
            return setSearchIsOpen(false)
        }

        setSearchIsOpen(true)
    }

    return (
        <div className="container">            
            <div className="loading" style={{ display: isLoaded ? "none" : "flex" }}>
                <div className="progress">
                    <span className="progress-bar" style={{width: `${loadingProgression * 100}%`}}></span>
                </div>
            </div>
            <button className='searchbtn' onClick={() => handleSearch(true)}>Search</button>
            {searchIsOpen && ( <Search searchIsOpen={searchIsOpen} handleSearch={handleSearch} /> )}
            <SideBar sidebarInfo={sidebarInfo} />
            <div className="unity">
                <Unity
                    unityProvider={unityProvider}
                    devicePixelRatio={window.devicePixelRatio}
                />
                {linksBoxIsOpen && ( <LinksBox linksBoxIsOpen={linksBoxIsOpen} handleLinksBox={handleLinksBox} links={links} /> )}
                {popUpIsOpen && ( <PopUp popUpInfo={popUpInfo} isOpen={popUpIsOpen} closePopUp={() => handlePopUp(false)} handleLinksBox={handleLinksBox} /> )}
            </div>
        </div>
    )
}